import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, unref as _unref, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "ielts-panel",
  "aria-labelledby": "ielts-panel-heading"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "ielts-panel__topbar" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "ielts-panel__notify-hint"
}
const _hoisted_6 = { class: "ielts-panel__layout" }
const _hoisted_7 = {
  class: "ielts-panel__social",
  "aria-label": "دوستان و پیام‌ها"
}
const _hoisted_8 = { class: "ielts-panel__main" }
const _hoisted_9 = ["aria-busy"]
const _hoisted_10 = {
  key: 0,
  class: "today-progress__error"
}
const _hoisted_11 = { class: "today-progress__stats" }
const _hoisted_12 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "currentColor"
}
const _hoisted_13 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_14 = {
  key: 2,
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_15 = {
  key: 3,
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "currentColor"
}
const _hoisted_16 = { class: "today-progress__text" }
const _hoisted_17 = {
  class: "ielts-panel__cards",
  role: "radiogroup",
  "aria-labelledby": "ielts-panel-heading"
}
const _hoisted_18 = ["id", "aria-checked", "aria-label", "onClick", "onKeydown"]
const _hoisted_19 = {
  key: 0,
  class: "service-card__beacon",
  "aria-hidden": "true"
}
const _hoisted_20 = { class: "service-card__icon" }
const _hoisted_21 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "22",
  height: "22",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.75",
  "aria-hidden": "true"
}
const _hoisted_22 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "22",
  height: "22",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.75",
  "aria-hidden": "true"
}
const _hoisted_23 = {
  key: 2,
  viewBox: "0 0 24 24",
  width: "22",
  height: "22",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.75",
  "aria-hidden": "true"
}
const _hoisted_24 = {
  key: 3,
  viewBox: "0 0 24 24",
  width: "22",
  height: "22",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.75",
  "aria-hidden": "true"
}
const _hoisted_25 = {
  key: 4,
  viewBox: "0 0 24 24",
  width: "22",
  height: "22",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.75",
  "aria-hidden": "true"
}
const _hoisted_26 = { class: "service-card__title" }
const _hoisted_27 = { class: "service-card__subtitle" }
const _hoisted_28 = { class: "service-card__footer" }
const _hoisted_29 = { class: "service-card__meta" }
const _hoisted_30 = { class: "ielts-panel__bottom" }
const _hoisted_31 = { class: "leitner-summary__head" }
const _hoisted_32 = { class: "leitner-summary__due" }
const _hoisted_33 = { class: "leitner-summary__body" }
const _hoisted_34 = { class: "leitner-summary__boxes" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "ielts-panel__mascot-slot" }
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  class: "ielts-panel__sidebar",
  "aria-label": "اتاق‌های اسپیکینگ و جدول امتیازات"
}

import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import LeaderBord from "@/components/leaderBord.vue";
import ActiveSpeakingRooms from "@/components/ActiveSpeakingRooms.vue";
import FriendshipBox from "@/components/FriendshipBox.vue";
import SocialInbox from "@/components/SocialInbox.vue";
import ProfileMenu from "@/components/ProfileMenu.vue";
import cocoMascot from "@/assets/coco-mascot.png";
import cocoLeitner from "@/assets/coco-leitner.png";
import { getMyStreak } from "@/api/streaks";
import { getLeitnerOverview } from "@/api/leitner";
import { handleError } from "@/services/errorHandler";
import {
  enablePush,
  notificationPermission,
  notificationsEnabled,
} from "@/composables/usePushNotifications";
import type { LeitnerOverview, Streak } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'IELTS',
  props: {
  defaultSelected: {
    type: String,
    default: "mock",
  },
},
  emits: ["select"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const router = useRouter();

const servicesBase = [
  {
    id: "mock",
    title: "آزمون شبیه‌ساز",
    subtitle: "آزمون کامل آیلتس در شرایط واقعی",
    meta: "۴ آزمون در دسترس",
    icon: "clipboard",
  },
  {
    id: "speaking",
    title: "اسپیکینگ",
    subtitle: "تمرین مکالمه با هوش مصنوعی",
    meta: "۳ بخش تمرینی",
    icon: "mic",
  },
  {
    id: "writing",
    title: "رایتینگ",
    subtitle: "بهبود مهارت نوشتن Task 1 & Task 2",
    meta: "بازخورد هوشمند",
    icon: "pen",
  },
  {
    id: "vocabulary",
    title: "جعبه لایتنر",
    subtitle: "مرور فاصله‌دار واژگان آیلتس",
    meta: "واژگان",
    icon: "book",
  },
  {
    id: "talk",
    title: "صحبت کنیم",
    subtitle: "نظر بده، پاسخ بگیر و لایک کن",
    meta: "جامعه یادگیری",
    icon: "chat",
  },
];

const streak = ref<Streak | null>(null);
const streakLoading = ref(false);
const streakError = ref<string | null>(null);
const leitner = ref<LeitnerOverview | null>(null);
const notifyBusy = ref(false);

const showNotifyPrompt = computed(
  () => notificationsEnabled() && notificationPermission.value === "default"
);

const showNotifyBlocked = computed(
  () => notificationsEnabled() && notificationPermission.value === "denied"
);

async function enableNotifications() {
  notifyBusy.value = true;
  try {
    await enablePush();
  } finally {
    notifyBusy.value = false;
  }
}

function toPersianDigits(value: number | string): string {
  return String(value).replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[Number(digit)]);
}

const services = computed(() =>
  servicesBase.map((service) => {
    if (service.id !== "vocabulary") return service;
    const due = leitner.value?.due_count ?? 0;
    return {
      ...service,
      meta:
        due > 0
          ? `${toPersianDigits(due)} کارت برای مرور`
          : `${toPersianDigits(leitner.value?.total_cards ?? 0)} کارت فعال`,
    };
  })
);

const todayProgress = computed(() => {
  const current = streak.value?.current_streak ?? 0;
  const goal = streak.value?.daily_goal ?? 1;
  const sessions = streak.value?.today.sessions_completed ?? 0;
  const minutes = streak.value?.today.practice_minutes ?? 0;
  const xp = streak.value?.today.xp_earned ?? 0;

  return [
    {
      id: "streak",
      label: "روز متوالی",
      value: toPersianDigits(current),
      icon: "flame",
      color: "#F59E0B",
    },
    {
      id: "goal",
      label: "هدف امروز",
      value: `${toPersianDigits(Math.min(sessions, goal))}/${toPersianDigits(goal)}`,
      icon: "target",
      color: "#7C4DFF",
    },
    {
      id: "time",
      label: "زمان تمرین",
      value: `${toPersianDigits(minutes)} دقیقه`,
      icon: "clock",
      color: "#79C26D",
    },
    {
      id: "xp",
      label: "امتیاز امروز",
      value: `${toPersianDigits(xp)} XP`,
      icon: "trophy",
      color: "#E8A317",
    },
  ];
});

const leitnerBoxes = computed(() => {
  if (leitner.value?.boxes?.length) return leitner.value.boxes;
  return [1, 2, 3, 4, 5].map((box) => ({ box, count: 0 }));
});

async function loadStreak() {
  streakLoading.value = true;
  streakError.value = null;
  try {
    streak.value = await getMyStreak();
  } catch (e) {
    streakError.value = handleError(e, "IELTS.loadStreak");
  } finally {
    streakLoading.value = false;
  }
}

async function loadLeitner() {
  try {
    leitner.value = await getLeitnerOverview();
  } catch (e) {
    handleError(e, "IELTS.loadLeitner");
  }
}

onMounted(() => {
  loadStreak();
  loadLeitner();
});

const active = ref(localStorage.getItem("selectedService") || props.defaultSelected);

function select(id) {
  active.value = id;
  localStorage.setItem("selectedService", id);
  emit("select", id);
}

function openService(id) {
  select(id);

  const routes = {
    mock: "/mock-exams",
    speaking: "/dashboard/speaking",
    writing: "/dashboard/writing",
    vocabulary: "/dashboard/leitner",
    talk: "/dashboard/talk",
  };

  if (routes[id]) {
    router.push(routes[id]);
  }
}

function openLeitner() {
  router.push("/dashboard/leitner");
}

function onKeydown(event, index) {
  const list = services.value;
  const last = list.length - 1;
  let nextIndex = null;

  if (event.key === "ArrowRight" || event.key === "ArrowDown") {
    nextIndex = index === last ? 0 : index + 1;
  } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
    nextIndex = index === 0 ? last : index - 1;
  }

  if (nextIndex !== null) {
    event.preventDefault();
    const id = list[nextIndex].id;
    select(id);
    const el = document.getElementById(`service-card-${id}`);
    el?.focus();
  } else if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    openService(list[index].id);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"ielts-panel__decor\" aria-hidden=\"true\" data-v-0996bba7><svg class=\"leaf leaf--1\" viewBox=\"0 0 48 64\" fill=\"none\" data-v-0996bba7><path d=\"M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z\" fill=\"#A5B94F\" opacity=\"0.55\" data-v-0996bba7></path><path d=\"M24 8v46\" stroke=\"#8FA03E\" stroke-width=\"1.5\" stroke-linecap=\"round\" opacity=\"0.5\" data-v-0996bba7></path></svg><svg class=\"leaf leaf--2\" viewBox=\"0 0 48 64\" fill=\"none\" data-v-0996bba7><path d=\"M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z\" fill=\"#A5B94F\" opacity=\"0.45\" data-v-0996bba7></path><path d=\"M24 8v46\" stroke=\"#8FA03E\" stroke-width=\"1.5\" stroke-linecap=\"round\" opacity=\"0.4\" data-v-0996bba7></path></svg><svg class=\"leaf leaf--3\" viewBox=\"0 0 48 64\" fill=\"none\" data-v-0996bba7><path d=\"M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z\" fill=\"#A5B94F\" opacity=\"0.5\" data-v-0996bba7></path><path d=\"M24 8v46\" stroke=\"#8FA03E\" stroke-width=\"1.5\" stroke-linecap=\"round\" opacity=\"0.45\" data-v-0996bba7></path></svg><svg class=\"leaf leaf--4\" viewBox=\"0 0 48 64\" fill=\"none\" data-v-0996bba7><path d=\"M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z\" fill=\"#A5B94F\" opacity=\"0.4\" data-v-0996bba7></path><path d=\"M24 8v46\" stroke=\"#8FA03E\" stroke-width=\"1.5\" stroke-linecap=\"round\" opacity=\"0.35\" data-v-0996bba7></path></svg><svg class=\"leaf leaf--5\" viewBox=\"0 0 48 64\" fill=\"none\" data-v-0996bba7><path d=\"M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z\" fill=\"#A5B94F\" opacity=\"0.4\" data-v-0996bba7></path><path d=\"M24 8v46\" stroke=\"#8FA03E\" stroke-width=\"1.5\" stroke-linecap=\"round\" opacity=\"0.35\" data-v-0996bba7></path></svg></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (showNotifyPrompt.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ielts-panel__notify",
              disabled: notifyBusy.value,
              onClick: enableNotifications
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", {
                class: "bi bi-bell",
                "aria-hidden": "true"
              }, null, -1),
              _createTextVNode(" فعال‌سازی اعلان‌ها ", -1)
            ]))], 8, _hoisted_4))
          : (showNotifyBlocked.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " اعلان‌های مرورگر مسدود است. از قفل کنار نوار آدرس، Notifications را Allow کنید. "))
            : _createCommentVNode("", true),
        _createVNode(ProfileMenu)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("aside", _hoisted_7, [
          _createVNode(FriendshipBox),
          _createVNode(SocialInbox)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("section", {
            class: "today-progress",
            "aria-label": "پیشرفت امروز",
            "aria-busy": streakLoading.value
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "today-progress__title" }, "پیشرفت امروز", -1)),
            (streakError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(streakError.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(todayProgress.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: _normalizeClass(["today-progress__item", { 'today-progress__item--loading': streakLoading.value }])
                }, [
                  _createElementVNode("span", {
                    class: "today-progress__icon",
                    style: _normalizeStyle({ background: `${item.color}22`, color: item.color }),
                    "aria-hidden": "true"
                  }, [
                    (item.icon === 'flame')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("path", { d: "M12 2s4 4.2 4 8a4 4 0 1 1-8 0c0-2.4 1.4-4.6 2.6-6.2.4-.5 1.4.1 1.2.8C11.4 6.2 12 8 12 9c0-3-1.5-5.5-3-7 3 1 5 4 5 7a5 5 0 1 1-10 0c0-3.5 2.5-6.5 5-9z" }, null, -1)
                        ]))]))
                      : (item.icon === 'target')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_13, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "8"
                            }, null, -1),
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "4"
                            }, null, -1),
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "1",
                              fill: "currentColor"
                            }, null, -1)
                          ]))]))
                        : (item.icon === 'clock')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_14, [...(_cache[3] || (_cache[3] = [
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "12",
                                r: "9"
                              }, null, -1),
                              _createElementVNode("path", {
                                d: "M12 7v5l3 2",
                                "stroke-linecap": "round"
                              }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("path", { d: "M12 2l2.4 4.9 5.4.8-3.9 3.8.9 5.4L12 14.8 7.2 17l.9-5.4L4.2 7.7l5.4-.8L12 2z" }, null, -1)
                            ]))]))
                  ], 4),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("strong", null, _toDisplayString(item.value), 1),
                    _createElementVNode("span", null, _toDisplayString(item.label), 1)
                  ])
                ], 2))
              }), 128))
            ])
          ], 8, _hoisted_9),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "ielts-panel__intro" }, [
            _createElementVNode("span", { class: "ielts-panel__eyebrow" }, "مرکز تمرین"),
            _createElementVNode("h2", {
              id: "ielts-panel-heading",
              class: "ielts-panel__title"
            }, " امروز دوست داری چی تمرین کنیم؟ "),
            _createElementVNode("p", { class: "ielts-panel__subtitle" }, " بخش مورد نظر رو انتخاب کن تا تمرینات با سطح و پیشرفتت هماهنگ بشه. ")
          ], -1)),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service, index) => {
              return (_openBlock(), _createElementBlock("button", {
                id: `service-card-${service.id}`,
                key: service.id,
                type: "button",
                role: "radio",
                class: _normalizeClass(["service-card", { 'service-card--active': active.value === service.id }]),
                "aria-checked": active.value === service.id,
                "aria-label": `${service.title}: ${service.subtitle}`,
                onClick: ($event: any) => (openService(service.id)),
                onKeydown: (e) => onKeydown(e, index)
              }, [
                (active.value === service.id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_20, [
                  (service.icon === 'clipboard')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_21, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("path", {
                          d: "M9 11l3 3L22 4",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, null, -1),
                        _createElementVNode("path", {
                          d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, null, -1)
                      ]))]))
                    : (service.icon === 'mic')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_22, [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("path", { d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" }, null, -1),
                          _createElementVNode("path", {
                            d: "M19 10v2a7 7 0 0 1-14 0v-2",
                            "stroke-linecap": "round"
                          }, null, -1),
                          _createElementVNode("line", {
                            x1: "12",
                            y1: "19",
                            x2: "12",
                            y2: "23",
                            "stroke-linecap": "round"
                          }, null, -1),
                          _createElementVNode("line", {
                            x1: "8",
                            y1: "23",
                            x2: "16",
                            y2: "23",
                            "stroke-linecap": "round"
                          }, null, -1)
                        ]))]))
                      : (service.icon === 'pen')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_23, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("path", {
                              d: "M12 20h9",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, null, -1),
                            _createElementVNode("path", {
                              d: "M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, null, -1)
                          ]))]))
                        : (service.icon === 'book')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_24, [...(_cache[9] || (_cache[9] = [
                              _createElementVNode("path", {
                                d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, null, -1),
                              _createElementVNode("path", {
                                d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_25, [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("path", {
                                d: "M21 15a4 4 0 0 1-4 4H7l-4 4V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, null, -1)
                            ]))]))
                ]),
                _createElementVNode("h3", _hoisted_26, _toDisplayString(service.title), 1),
                _createElementVNode("p", _hoisted_27, _toDisplayString(service.subtitle), 1),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(service.meta), 1),
                  _cache[11] || (_cache[11] = _createElementVNode("svg", {
                    class: "service-card__arrow",
                    viewBox: "0 0 24 24",
                    width: "14",
                    height: "14",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", {
                      d: "M7 17 17 7M7 7h10v10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1))
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("span", {
                  class: "service-card__bar",
                  "aria-hidden": "true"
                }, null, -1))
              ], 42, _hoisted_18))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("section", {
              class: "leitner-summary",
              "aria-label": "جعبه لایتنر",
              onClick: openLeitner,
              onKeydown: _withKeys(openLeitner, ["enter"]),
              role: "button",
              tabindex: "0"
            }, [
              _createElementVNode("div", _hoisted_31, [
                _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "leitner-summary__title" }, "جعبه لایتنر", -1)),
                _createElementVNode("span", _hoisted_32, _toDisplayString(leitner.value
                      ? `${toPersianDigits(leitner.value.due_count)} آماده مرور`
                      : "—"), 1)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leitnerBoxes.value, (box) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: box.box,
                      class: _normalizeClass(["leitner-summary__box", `leitner-summary__box--${box.box}`])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(toPersianDigits(box.box)), 1),
                      _createElementVNode("strong", null, _toDisplayString(toPersianDigits(box.count)), 1)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("img", {
                  src: _unref(cocoLeitner),
                  alt: "",
                  class: "leitner-summary__mascot",
                  "aria-hidden": "true"
                }, null, 8, _hoisted_35)
              ])
            ], 32),
            _createElementVNode("div", _hoisted_36, [
              _cache[14] || (_cache[14] = _createStaticVNode("<svg class=\"ielts-panel__mascot-leaf ielts-panel__mascot-leaf--left\" viewBox=\"0 0 48 64\" fill=\"none\" aria-hidden=\"true\" data-v-0996bba7><path d=\"M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z\" fill=\"#A5B94F\" opacity=\"0.5\" data-v-0996bba7></path><path d=\"M24 8v46\" stroke=\"#8FA03E\" stroke-width=\"1.5\" stroke-linecap=\"round\" opacity=\"0.45\" data-v-0996bba7></path></svg><svg class=\"ielts-panel__mascot-leaf ielts-panel__mascot-leaf--right\" viewBox=\"0 0 48 64\" fill=\"none\" aria-hidden=\"true\" data-v-0996bba7><path d=\"M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z\" fill=\"#A5B94F\" opacity=\"0.45\" data-v-0996bba7></path><path d=\"M24 8v46\" stroke=\"#8FA03E\" stroke-width=\"1.5\" stroke-linecap=\"round\" opacity=\"0.4\" data-v-0996bba7></path></svg>", 2)),
              _createElementVNode("img", {
                src: _unref(cocoMascot),
                alt: "",
                class: "ielts-panel__mascot",
                "aria-hidden": "true"
              }, null, 8, _hoisted_37)
            ])
          ])
        ]),
        _createElementVNode("aside", _hoisted_38, [
          _createVNode(ActiveSpeakingRooms),
          _createVNode(LeaderBord)
        ])
      ])
    ])
  ]))
}
}

})